import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { exportSMReportApi } from 'api';
import {
  Button,
  Grid,
  Typography,
  Card,
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';


const Report = () => {
  const dispatch = useDispatch();
  const { loadingSMReport } = useSelector((state) => state.admin);

  const date = new Date();
  date.setMonth(date.getMonth() - 6);

  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(new Date());

  const handleClickReport = () => {
    exportSMReportApi({ dispatch, fromDate: startDate, toDate: endDate });
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <Typography variant="h3" className="mb-8">Report</Typography>
      <Card
        className="p-4 mb-4"
        elevation={25}
      >
        <Grid container className="p-4 flex justify-between">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              className="mb-4"
              variant="inline"
              label="Start Date"
              autoOk
              format="MM/dd/yyyy"
              value={startDate}
              onChange={setStartDate}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              className="mb-4"
              error={endDate < startDate}
              helperText={endDate < startDate && 'End Date cant be less than Start Date'}
              variant="inline"
              label="End Date"
              autoOk
              format="MM/dd/yyyy"
              value={endDate}
              onChange={setEndDate}
            />
          </MuiPickersUtilsProvider>
          <Button
            variant="contained"
            color="primary"
            className="uppercase"
            disabled={endDate < startDate}
            onClick={handleClickReport}
          >
            Download Shop Manager Report
          </Button>
        </Grid>
      </Card>
      <BackdropCircular loading={loadingSMReport} />
    </div>
  );
};

export default Report;
